import { render, staticRenderFns } from "./FatturaProduzione.vue?vue&type=template&id=3aa13116"
import script from "./FatturaProduzione.vue?vue&type=script&lang=js"
export * from "./FatturaProduzione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports